// extracted by mini-css-extract-plugin
export default {"PrimaryTitleWrapper":"Intermediaries_PrimaryTitleWrapper__EluIv","MainWrapper":"Intermediaries_MainWrapper__Rpi26","ListWrapper":"Intermediaries_ListWrapper__q4BXJ"};